import { ConnectionNames } from "../Contracts";
import { createSportsbookConnection } from "../C_Sportsbook/Helpers";
import { createBetSlipConnection } from "../C_Betslip/Helpers";
import { createCaptorConnection } from "../C_Captor/Helpers";
import { createCaptchaConnection } from "../C_Captcha/Helpers";
import { createRealityCheckConnection } from "../C_RealityCheck/Helpers";
import { createSearchConnection } from "../C_Search/Helpers";
import { createPlayerDataConnection } from "../C_PlayerData/Helpers";
import { createLoginConnection } from "../C_Login/Helpers";
import { createBetsReportingConnection } from "../C_BetsReporting/Helpers";
import { createCasinoConnection } from "../C_Casino/Helpers";
import { createOpenBetsConnection } from "../C_OpenBets/Helpers";
import { createCasinoPlayerActivityConnection } from "../C_CasinoPlayerActivity/Helpers";
import { createTournamentsConnection } from "../C_Tournaments/Helpers";
import { createYourBetConnection } from "../C_YourBet/Helpers";
export const ConnectionsFactory = {
    [ConnectionNames.sports]: createSportsbookConnection,
    [ConnectionNames.betslip]: createBetSlipConnection,
    [ConnectionNames.captor]: createCaptorConnection,
    [ConnectionNames.captcha]: createCaptchaConnection,
    [ConnectionNames.realityCheck]: createRealityCheckConnection,
    [ConnectionNames.search]: createSearchConnection,
    [ConnectionNames.player]: createPlayerDataConnection,
    [ConnectionNames.login]: createLoginConnection,
    [ConnectionNames.betsReporting]: createBetsReportingConnection,
    [ConnectionNames.casino]: createCasinoConnection,
    [ConnectionNames.openBets]: createOpenBetsConnection,
    [ConnectionNames.casinoPlayerActivity]: createCasinoPlayerActivityConnection,
    [ConnectionNames.tournaments]: createTournamentsConnection,
    [ConnectionNames.yourBet]: createYourBetConnection
};
//# sourceMappingURL=ConnectionsFactory.js.map